import { Paper } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(4),
    margin: 'auto',

    width: '90%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
}))

const AuthCard = (props) => {
  const { classes } = useStyles()

  return (
    <Paper elevation={4} className={classes.root}>
      {props.children}
    </Paper>
  )
}

export default AuthCard
